import {appendElementAttributes} from './utils';
import './api/soundcloudWidgetApi';

export default class SndWidgetImpl {
    targetElementId = String();
    url;
    widget;
    paused = Boolean(true);

    constructor(targetElementId, widgetUrl) {
        this.targetElementId = targetElementId;
        this.url = widgetUrl;
    }

    static async createInstance(target, url) {
        const instance = new SndWidgetImpl(target, url);
        await instance.setupWidgetIframe();
        return instance;
    }

    setPauseState(value) {
        this.paused = value;
    }

    onMounted(callback) {
        this.widget.bind(SC.Widget.Events.READY, () => {
            this.widget.isPaused(this.setPauseState);
            this.widget.getDuration((d) => {
                callback({duration: d})
            });
        });
    }

    onPlaying(callback) {
        this.widget.bind(SC.Widget.Events.PLAY_PROGRESS, callback);
    }

    onLoading(callback) {
        this.widget.bind(SC.Widget.Events.LOAD_PROGRESS, (e) => {
            callback(e);
        })
    }

    onPlay(callback) {
        this.widget.bind(SC.Widget.Events.PLAY, callback);
    }

    onPause(callback) {
        this.widget.bind(SC.Widget.Events.PAUSE, callback);
    }

    goTo(position) {
        this.widget.seekTo(position);
    }

    getTimelinePosition(callback) {
        this.widget.bind(SC.Widget.Events.SEEK, callback);
    }

    play() {
        this.widget.play();
    }

    pause() {
        this.widget.pause();
    }

    setupWidgetIframe() {
        const options = {
            id: `snd-widget-${Date.now()}`,
            width: '100%',
            height: '50%',
            scrolling: 'no',
            allow: 'autoplay; encrypted-media;',
            frameBorder: 'no',
            src: `https://w.soundcloud.com/player/?url=${this.url}&amp;auto_play=1&amp;`
        }
        return new Promise((resolve) => {
            const sndWidgetIframe = appendElementAttributes(document.createElement('iframe'), options);
            const rootEl = document.querySelector(this.targetElementId);
            rootEl.appendChild(sndWidgetIframe);
            sndWidgetIframe.onload = () => {
                this.widget = SC.Widget(sndWidgetIframe.id);
                resolve();
            }
        });
    }
}